const checkoutStaticText = {
    BILLING_ADDRESS: 'Billing Address',
    PAYMENT_METHODS: 'Payment Method',
    EMAIL_NOTIFICATION_MESSAGE: "We'll email you when your order is ready for pickup.",
    NEED_IT_SOONER: 'Need it sooner?',
    FREE: 'FREE',
    EXPEDITED_DELIVERY_OPTIONS: 'Expedited Delivery Options',
    EDIT_DELIVERY_OPTIONS: 'Edit Delivery Options',
    EDIT_SHIPPING: 'Edit Shipping',
    CANCEL_ORDER: 'Cancel Order',
    STANDARD_DELIVERY: 'Standard Delivery',
};

export const curbSideConstants = {
    CURBSIDE_PICKUP: 'Curbside Pickup',
};

export default checkoutStaticText;
